import type { MiroBoardResponse } from '@docnboard/rest';
import { atom } from 'jotai';

export type Board = MiroBoardResponse;

export type MiroAtom = {
  openModal: boolean;
};

export const miroAtom = atom<MiroAtom>({
  openModal: false,
});
